var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
import { PossibleStatusChange } from "./../models/V1/Companies/VatRegistrations/PossibleStatusChange";
import { VatRegistrationStatusChangeHistory } from "./../models/V1/Companies/VatRegistrations/VatRegistrationStatusChangeHistory";
import { VatRegSearchResult } from "./../models/V1/Companies/VatRegistrations/Search/VatRegSearchResult";
export class CompaniesVatRegistrations {
  /**
   * Creates an instance of CompaniesVatRegistrations.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof CompaniesVatRegistrations
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param ChangeBankAccountRq_ _changeBankAccountRq
   * @returns Promise<ChangeBankAccountRq_>
   * @memberof CompaniesVatRegistrations
   */
  changeBankAccount(pChangeBankAccountRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/bankaccount",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pChangeBankAccountRq.companyId, required: true },
      { name: "vatRegistrationId", value: pChangeBankAccountRq.vatRegistrationId, required: true }
    ]);
    client.addBody({ value: pChangeBankAccountRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeEUVATNumberDateRq_ _changeEUVATNumberDateRq
   * @returns Promise<ChangeEUVATNumberDateRq_>
   * @memberof CompaniesVatRegistrations
   */
  changeEUVATNumberDate(pChangeEUVATNumberDateRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/euvatnumber/registrationdate",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pChangeEUVATNumberDateRq.companyId, required: true },
      { name: "vatRegistrationId", value: pChangeEUVATNumberDateRq.vatRegistrationId, required: true }
    ]);
    client.addBody({ value: pChangeEUVATNumberDateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeFrequenciesRq_ _changeFrequenciesRq
   * @returns Promise<ChangeFrequenciesRq_>
   * @memberof CompaniesVatRegistrations
   */
  changeFrequencies(pChangeFrequenciesRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/frequencies",
      "PATCH",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pChangeFrequenciesRq.companyId, required: true },
      { name: "vatRegistrationId", value: pChangeFrequenciesRq.vatRegistrationId, required: true }
    ]);
    client.addBody({ value: pChangeFrequenciesRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeLocalVATNumberDateRq_ _changeLocalVATNumberDateRq
   * @returns Promise<ChangeLocalVATNumberDateRq_>
   * @memberof CompaniesVatRegistrations
   */
  changeLocalVATNumberDate(pChangeLocalVATNumberDateRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/localvatnumber/registrationdate",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pChangeLocalVATNumberDateRq.companyId, required: true },
      { name: "vatRegistrationId", value: pChangeLocalVATNumberDateRq.vatRegistrationId, required: true }
    ]);
    client.addBody({ value: pChangeLocalVATNumberDateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangePaymentReferenceRq_ _changePaymentReferenceRq
   * @returns Promise<ChangePaymentReferenceRq_>
   * @memberof CompaniesVatRegistrations
   */
  changePaymentReference(pChangePaymentReferenceRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/paymentreference",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pChangePaymentReferenceRq.companyId, required: true },
      { name: "vatRegistrationId", value: pChangePaymentReferenceRq.vatRegistrationId, required: true }
    ]);
    client.addBody({ value: pChangePaymentReferenceRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeStartDateRq_ _changeStartDateRq
   * @returns Promise<ChangeStartDateRq_>
   * @memberof CompaniesVatRegistrations
   */
  changeStartDate(pChangeStartDateRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/startDate",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pChangeStartDateRq.companyId, required: true },
      { name: "vatRegistrationId", value: pChangeStartDateRq.vatRegistrationId, required: true }
    ]);
    client.addBody({ value: pChangeStartDateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeStatusRq_ _changeStatusRq
   * @returns Promise<ChangeStatusRq_>
   * @memberof CompaniesVatRegistrations
   */
  changeStatus(pChangeStatusRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/status",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pChangeStatusRq.companyId, required: true },
      { name: "vatRegistrationId", value: pChangeStatusRq.vatRegistrationId, required: true }
    ]);
    client.addBody({ value: pChangeStatusRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 204 },
        { statusCode: 400, clazz: ApiError },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 409, clazz: ApiError },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeTaxIdentifierRq_ _changeTaxIdentifierRq
   * @returns Promise<ChangeTaxIdentifierRq_>
   * @memberof CompaniesVatRegistrations
   */
  changeTaxIdentifier(pChangeTaxIdentifierRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/taxidentifier",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pChangeTaxIdentifierRq.companyId, required: true },
      { name: "vatRegistrationId", value: pChangeTaxIdentifierRq.vatRegistrationId, required: true }
    ]);
    client.addBody({ value: pChangeTaxIdentifierRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeTaxOfficeIdRq_ _changeTaxOfficeIdRq
   * @returns Promise<ChangeTaxOfficeIdRq_>
   * @memberof CompaniesVatRegistrations
   */
  changeTaxOfficeId(pChangeTaxOfficeIdRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/taxofficeid",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pChangeTaxOfficeIdRq.companyId, required: true },
      { name: "vatRegistrationId", value: pChangeTaxOfficeIdRq.vatRegistrationId, required: true }
    ]);
    client.addBody({ value: pChangeTaxOfficeIdRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateAdministratorRq_ _updateAdministratorRq
   * @returns Promise<UpdateAdministratorRq_>
   * @memberof CompaniesVatRegistrations
   */
  updateAdministrator(pUpdateAdministratorRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/administrator",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pUpdateAdministratorRq.companyId, required: true },
      { name: "vatRegistrationId", value: pUpdateAdministratorRq.vatRegistrationId, required: true }
    ]);
    client.addBody({ value: pUpdateAdministratorRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DeleteAdministratorRq_ _deleteAdministratorRq
   * @returns Promise<DeleteAdministratorRq_>
   * @memberof CompaniesVatRegistrations
   */
  deleteAdministrator(pDeleteAdministratorRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/administrator",
      "DELETE",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pDeleteAdministratorRq.companyId, required: true },
      { name: "vatRegistrationId", value: pDeleteAdministratorRq.vatRegistrationId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadDeregistrationDocumentRq_ _downloadDeregistrationDocumentRq
   * @returns Promise<DownloadDeregistrationDocumentRq_>
   * @memberof CompaniesVatRegistrations
   */
  downloadDeregistrationDocument(pDownloadDeregistrationDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/documents/deregistrationdocument",
      "GET",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pDownloadDeregistrationDocumentRq.companyId, required: true },
      { name: "vatRegistrationId", value: pDownloadDeregistrationDocumentRq.vatRegistrationId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadDocumentRq_ _downloadDocumentRq
   * @returns Promise<DownloadDocumentRq_>
   * @memberof CompaniesVatRegistrations
   */
  downloadDocument(pDownloadDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/documents/{templateId}",
      "GET",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    client.addQueryParams([{ name: "type", value: pDownloadDocumentRq.type }]);
    client.addPathParams([
      { name: "companyId", value: pDownloadDocumentRq.companyId, required: true },
      { name: "vatRegistrationId", value: pDownloadDocumentRq.vatRegistrationId, required: true },
      { name: "templateId", value: pDownloadDocumentRq.templateId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GenerateDocumentRq_ _generateDocumentRq
   * @returns Promise<GenerateDocumentRq_>
   * @memberof CompaniesVatRegistrations
   */
  generateDocument(pGenerateDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/documents/{templateId}",
      "POST",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pGenerateDocumentRq.companyId, required: true },
      { name: "vatRegistrationId", value: pGenerateDocumentRq.vatRegistrationId, required: true },
      { name: "templateId", value: pGenerateDocumentRq.templateId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadPoaRevokedConfirmationDocumentRq_ _downloadPoaRevokedConfirmationDocumentRq
   * @returns Promise<DownloadPoaRevokedConfirmationDocumentRq_>
   * @memberof CompaniesVatRegistrations
   */
  downloadPoaRevokedConfirmationDocument(pDownloadPoaRevokedConfirmationDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/documents/poarevokeconfirmationdocument",
      "GET",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pDownloadPoaRevokedConfirmationDocumentRq.companyId, required: true },
      { name: "vatRegistrationId", value: pDownloadPoaRevokedConfirmationDocumentRq.vatRegistrationId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadVatCertificateRq_ _downloadVatCertificateRq
   * @returns Promise<DownloadVatCertificateRq_>
   * @memberof CompaniesVatRegistrations
   */
  downloadVatCertificate(pDownloadVatCertificateRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/certificates/{certificateType}",
      "GET",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pDownloadVatCertificateRq.companyId, required: true },
      { name: "vatRegistrationId", value: pDownloadVatCertificateRq.vatRegistrationId, required: true },
      { name: "certificateType", value: pDownloadVatCertificateRq.certificateType, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ExportRq_ _exportRq
   * @returns Promise<ExportRq_>
   * @memberof CompaniesVatRegistrations
   */
  export(pExportRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/vatregistrations/export", "POST", "application/json; charset=UTF-8", "text/csv, application/json", options);
    client.addBody({ value: pExportRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 400, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetAvailableStatusChangesRq_ _getAvailableStatusChangesRq
   * @returns Promise<GetAvailableStatusChangesRq_>
   * @memberof CompaniesVatRegistrations
   */
  getAvailableStatusChanges(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/vatregistrations/statuses", "GET", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: PossibleStatusChange, isArray: true },
        { statusCode: 403, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetStatusChangeHistoryRq_ _getStatusChangeHistoryRq
   * @returns Promise<GetStatusChangeHistoryRq_>
   * @memberof CompaniesVatRegistrations
   */
  getStatusChangeHistory(pGetStatusChangeHistoryRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/statuschanges",
      "GET",
      "application/json; charset=UTF-8",
      "application/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pGetStatusChangeHistoryRq.companyId, required: true },
      { name: "vatRegistrationId", value: pGetStatusChangeHistoryRq.vatRegistrationId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: VatRegistrationStatusChangeHistory, isArray: true },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SearchRq_ _searchRq
   * @returns Promise<SearchRq_>
   * @memberof CompaniesVatRegistrations
   */
  search(pSearchRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/vatregistrations/search", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addBody({ value: pSearchRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: VatRegSearchResult },
        { statusCode: 400, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadDocumentRq_ _uploadDocumentRq
   * @returns Promise<UploadDocumentRq_>
   * @memberof CompaniesVatRegistrations
   */
  uploadDocument(pUploadDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/documents",
      "POST",
      "multipart/form-data",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pUploadDocumentRq.companyId, required: true },
      { name: "vatRegistrationId", value: pUploadDocumentRq.vatRegistrationId, required: true }
    ]);
    client.addFormData("multipart/form-data", [{ name: "file", value: pUploadDocumentRq.file }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadSignedDocumentRq_ _uploadSignedDocumentRq
   * @returns Promise<UploadSignedDocumentRq_>
   * @memberof CompaniesVatRegistrations
   */
  uploadSignedDocument(pUploadSignedDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/vatregistrations/{vatRegistrationId}/documents/{templateId}/signed",
      "PUT",
      "multipart/form-data",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pUploadSignedDocumentRq.companyId, required: true },
      { name: "vatRegistrationId", value: pUploadSignedDocumentRq.vatRegistrationId, required: true },
      { name: "templateId", value: pUploadSignedDocumentRq.templateId, required: true }
    ]);
    client.addFormData("multipart/form-data", [{ name: "file", value: pUploadSignedDocumentRq.file }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
export var DownloadDocumentType = /* @__PURE__ */ ((DownloadDocumentType2) => {
  DownloadDocumentType2["Unsigned"] = "Unsigned";
  DownloadDocumentType2["Signed"] = "Signed";
  return DownloadDocumentType2;
})(DownloadDocumentType || {});
export var DownloadVatCertificateCertificateType = /* @__PURE__ */ ((DownloadVatCertificateCertificateType2) => {
  DownloadVatCertificateCertificateType2["Local"] = "Local";
  DownloadVatCertificateCertificateType2["Eu"] = "Eu";
  return DownloadVatCertificateCertificateType2;
})(DownloadVatCertificateCertificateType || {});
